import { closeModal } from '@va/dashboard/actions/ui';
import { getWebsiteTimezone } from '@va/dashboard/selectors/core';
import { isModalOpen } from '@va/dashboard/selectors/ui';
import { useTranslate } from '@va/localization';
import { ConfirmationModal } from '@va/shared/util-confirmation';
import { confirmUpgradeWithCancelledSubscription } from '@va/standalone/shared/actions';
import { modalName } from '@va/standalone/shared/constants';
import { getNoOfDaysUntil } from '@va/standalone/shared/helpers';
import {
  getIsSubscriptionPermanentlyCanceled,
  getLastSubscriptionExpirationDate,
} from '@va/standalone/shared/selectors';
import { Button } from '@va/ui/design-system';
import { useDispatch, useSelector } from 'react-redux';

const UpgradeWithCancelledSubscriptionModal = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => isModalOpen(state, modalName.UPGRADE_WITH_CANCELLED_SUBSCRIPTION));
  const isSubscriptionPermanentlyCanceled = useSelector(getIsSubscriptionPermanentlyCanceled);
  const timezone = useSelector(getWebsiteTimezone);
  const expiresAt = useSelector(getLastSubscriptionExpirationDate);
  const daysLeft = getNoOfDaysUntil(expiresAt, timezone);

  const onClose = () => dispatch(closeModal(modalName.UPGRADE_WITH_CANCELLED_SUBSCRIPTION));
  const onConfirm = () => {
    dispatch(confirmUpgradeWithCancelledSubscription());
    onClose();
  };

  if (!isOpen || !isSubscriptionPermanentlyCanceled) return null;

  return (
    <ConfirmationModal
      title={translate('subscription.upgradeWithCancelled.confirmTitle')}
      info={translate('subscription.upgradeWithCancelled.confirmMessage', { daysLeft })}
      onClose={onClose}
      isOpen={isOpen}
      footerButtons={
        <div className='flex flex-row justify-end gap-3'>
          <Button color='tertiary' text={translate('button.cancel')} onClick={onClose} />
          <Button color='primary' text={translate('button.upgrade')} onClick={onConfirm} />
        </div>
      }
    />
  );
};

export default UpgradeWithCancelledSubscriptionModal;
